import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './CorporateTraveler.css';



const CorporateTraveler = () => {
    return (
        <>
        
            <div className="corporate-traveler-section"
                style={{ '--background-image': `url(${"https://blueberrywebsites.azureedge.net/bbt/images/corporate-map.png"})` }}
            >
                <div className="container ">
                    <div className="row">
                        <div className="col-xxl-6 col-md-6 col-sm-12 pe-md-0">
                            <div className="left-side  d-flex justify-content-center">
                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/Home%20Side%20Girl.png" alt="" className="widh-girsl-right"  loading="lazy" />
                            </div>
                        </div>
                        <div className="col-xxl-6 col-md-6 col-sm-12 ps-md-0">
                            <div className="right-side">
                                <div className="">
                                    <h1 className="headings">Assures Every Experience with <span>Corporate Travel </span></h1>
                                </div>
                                <div className="d-flex mt-3">
                                    <div className="icon mt-3">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/A.png" alt="" loading="lazy"  />
                                    </div>
                                    <div className="content mt-4 ms-lg-3 ms-2">
                                        <h5 className="headings">Integrated Corporate User Experience</h5>
                                        <p className='grotesk-headings '>In a constantly evolving travel landscape, we blend expert knowledge with cutting-edge technology to deliver exceptional experiences. We prioritize your travelers, seamlessly connecting them with our support and innovative solutions for a journey they'll truly appreciate.</p>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="icon mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/B.png" alt=""  loading="lazy" />
                                    </div>
                                    <div className="content mt-4 ms-lg-3 ms-2">
                                        <h5 className="headings">Risk-Free Travels </h5>
                                        <p className='grotesk-headings '>Traveler safety shouldn’t be ignored; it must be carefully crafted. We work hand-in-hand with you and your risk management team to build proactive plans that safeguard your employees and ensure your duty of care while maintaining business continuity throughout every journey.
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div className="icon mt-2">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/C.png" alt="" loading="lazy"  />
                                    </div>
                                    <div className="content mt-3 ms-lg-3 ms-2">
                                        <h5 className="headings">Strategic Account Management
                                        </h5>
                                        <p className='grotesk-headings '>Building a travel program today is like building a skyscraper: you need a good architect. Our Account Management will help you develop a travel program that pushes boundaries and embodies your business, all while preventing costly mistakes before they happen.

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CorporateTraveler